import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const ReportContainer = styled.div({
  '.ReactTable .rt-tr':{
    cursor:'pointer'
  },

})